import { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { motion } from "framer-motion";
import api from "../lib/api";

export default function CmsPage() {
  const location = useLocation();
  const slug = location.pathname.replace(/^\/+/, "").split("/")[0] || "";
  const [page, setPage] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setPage(null);
    setError(null);
    if (!slug) {
      setError("Page not found.");
      return;
    }
    api
      .get(`/cms/${slug}`)
      .then((r) => setPage(r.data))
      .catch((e) =>
        setError(e?.response?.status === 404 ? "Page not found." : "Could not load page.")
      );
  }, [slug]);

  return (
    <article
      className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28"
      data-testid={`cms-page-${slug}`}
    >
      {error && (
        <div className="text-center" data-testid="cms-error">
          <p className="label-overline text-jow-gold">Oops</p>
          <h1 className="font-display text-4xl md:text-5xl mt-3 text-jow-navy">{error}</h1>
          <Link to="/" className="btn-secondary-jow mt-8 inline-flex" data-testid="cms-back">
            Back home
          </Link>
        </div>
      )}
      {page && (
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <span className="label-overline text-jow-gold">JewelleryOnWheels</span>
          <h1
            className="font-display text-4xl md:text-6xl mt-3 text-jow-navy tracking-tight"
            data-testid="cms-title"
            dangerouslySetInnerHTML={{ __html: page.title }}
          />
          <div
            className="prose prose-lg mt-8 text-jow-navy/80 leading-relaxed [&>p]:mt-4 [&>ol]:mt-4 [&>ol>li]:mt-2 [&>ol]:list-decimal [&>ol]:pl-6"
            data-testid="cms-content"
            dangerouslySetInnerHTML={{ __html: page.html }}
          />
        </motion.div>
      )}
    </article>
  );
}
